import type { FC } from "react"

interface Props {
  className?: string
}

const ChevronRight: FC<Props> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10.0003" r="10" fill="<%= color %>" />
      <path
        d="M9 13.0003L11.8284 10.1719L9 7.34347"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronRight
